import { Address } from '@eemo/api-client';

export class AddressHelper {
  constructor() {}

  static getFullAddress(address: Address) {
    let display = '';
    let hasValueBefore = false;
    const separator = ' ';

    if (address?.street) {
      display += address.street;
      hasValueBefore = true;
    }
    if (address?.complement) {
      display += (hasValueBefore ? separator : '') + address.complement;
      hasValueBefore = true;
    }
    if (address?.postalCode) {
      display += (hasValueBefore ? separator : '') + address.postalCode;
      hasValueBefore = true;
    }
    if (address?.city) {
      display += (hasValueBefore ? separator : '') + address.city;
      hasValueBefore = true;
    }
    // TODO reactivate when property of other country will be managed
    /*if (address?.country) {
      display += (hasValueBefore ? separator : '') + address.country;
      hasValueBefore = true;
    }*/

    return display;
  }

  static getCity(address: Address) {
    let display = '';
    if (address?.city) {
      display += address.city;
    }

    return display;
  }
}
